import { render } from "./ShowConversation.vue?vue&type=template&id=34343b45"
import script from "./ShowConversation.vue?vue&type=script&lang=js"
export * from "./ShowConversation.vue?vue&type=script&lang=js"

import exportComponent from "/home/tamo/projects/wedio/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__